import PdfEvent from "../../../../../lib/html5-software-library/src/ranj/pdf/PdfEvent";
import AbstractCommand from "../../../core/application/AbstractCommand";
import BackendService from "../../backend/controller/BackendService";
import ProgressModel from "../../progress/model/ProgressModel";
import SaveGameEvent from "../../savegame/event/SaveGameEvent";
import PersonalReportPdfDocument from "../document/PersonalReportPdfDocument";
import PersonalReportEvent from "../event/PersonalReportEvent";
import PersonalReportModel, { PersonalReportTip } from "../model/PersonalReportModel";

export default class GeneratePersonalReportCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher  
     * @param {PersonalReportPdfDocument} personalReportPdfDocument 
     * @param {PersonalReportModel} personalReportModel 
     * @param {ProgressModel} progressModel 
     * @param {BackendService} backendService 
     */
    constructor(dispatcher, personalReportPdfDocument, personalReportModel, progressModel, backendService) {
        super(dispatcher);

        this._personalReportPdfDocument = personalReportPdfDocument;
        this._personalReportModel = personalReportModel;
        this._progressModel = progressModel;
        this._backendService = backendService;

        this._handleGenerateReportCompleteBound = this._handleGenerateReportComplete.bind(this);
    }

    async execute(evt) {
        this._dispatcher.addEventListener(PdfEvent.GENERATE_REPORT_COMPLETE, this._handleGenerateReportCompleteBound);

        try {
            await this._loadPersonalReportModel();
            await this._personalReportPdfDocument.loadData();
            this._personalReportPdfDocument.generate();
        } catch (error) {
            console.error(`Error generating personal report: ${error}`);
            this.dispatch(PersonalReportEvent.ERROR);
        }
    }

    _handleGenerateReportComplete() {
        this._dispatcher.removeEventListener(PdfEvent.GENERATE_REPORT_COMPLETE, this._handleGenerateReportCompleteBound);
        this._personalReportPdfDocument.download();
    }

    async _loadPersonalReportModel() {
        if (this._personalReportModel.isPopulated()) {
            // Use cached personal report data if available.
            return;
        }

        const feedbackSummaries = this._progressModel.getFeedbackSummaries();
        const reflectionSummaries = this._progressModel.getReflectionSummaries();

        const performanceResponsePromise = this._backendService.reportPerformance({ feedbackSummaries, reflectionSummaries });
        const tipsResponsePromise = this._backendService.reportTips({ feedbackSummaries, reflectionSummaries });

        const [performanceResponse, tipsResponse] = await Promise.all([performanceResponsePromise, tipsResponsePromise]);

        this._personalReportModel.performance = performanceResponse.message;
        this._personalReportModel.addTips(tipsResponse.tips.map(tip => new PersonalReportTip(tip)));

        // Persist the personal report model in the savegame.
        this.dispatch(SaveGameEvent.SAVE);
    }
}